const middleware = {}

middleware['auth'] = require('../middleware/auth.ts')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['authed'] = require('../middleware/authed.ts')
middleware['authed'] = middleware['authed'].default || middleware['authed']

export default middleware
